import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import React from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import {
  currentPageIndexSpecificSearchAtom,
  refinersAtom,
  selectedLocationIdAtom,
  selectedRefinerItemsAtom,
  startRowSpecificSearchAtom,
  selectedSiteAtom,
  startRowGeneralSearchAtom,
  currentPageIndexGeneralSearchAtom,
} from '../utils/AtomConfig';
import Constants from '../utils/Constants';
import { Refiner } from './Refiner';
import { ComponentLocation } from '../models/ComponentLocation';

export function Refiners(props: { componentLocation: ComponentLocation }) {
  const selectedLocationId = useAtomValue(selectedLocationIdAtom);
  const selectedSite = useAtomValue(selectedSiteAtom);
  const refiners = useAtomValue(refinersAtom);
  const [selectedRefinerItems, setSelectedRefinerItems] = useAtom(
    selectedRefinerItemsAtom
  );
  const setCurrentPageIndexSpecificSearch = useSetAtom(currentPageIndexSpecificSearchAtom);
  const setStartRowSpecificSearch = useSetAtom(startRowSpecificSearchAtom);
  const setCurrentPageIndexGeneralSearch = useSetAtom(currentPageIndexGeneralSearchAtom);
  const setStartRowGeneralSearch = useSetAtom(startRowGeneralSearchAtom);

  function handleClickClearFilters() {
    setCurrentPageIndexSpecificSearch(1);
    setCurrentPageIndexGeneralSearch(1);
    setStartRowSpecificSearch(0);
    setStartRowGeneralSearch(0);
    setSelectedRefinerItems([]);
  }

  const filteredRefiners = refiners.filter(
    (refiner) => refiner.locationId === selectedLocationId
  );

  const isAnyFiltersSelected = selectedRefinerItems.length > 0;
  const isLocationSelected = selectedLocationId !== Constants.DEFAULT_ID;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          component='h2'
          variant='h5'
          sx={{ marginBottom: 1, color: '#003591' }}
        >
          Filter
        </Typography>

        {/* Only shows if there are any resources or item groups selected */}
        {isAnyFiltersSelected && (
          <Typography
            onClick={handleClickClearFilters}
            sx={{
              '&:hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
              },
            }}
          >
            Clear filter
          </Typography>
        )}
      </Box>

      {/* Show message if location is not selected */}
      {!isLocationSelected && (
        <Typography align='center' color='black' marginTop={2}>
          Please select location first
        </Typography>
      )}

      {/* Dynamic refiners */}
      {!!selectedSite &&
        filteredRefiners.map(
          (refiner) =>
            ((selectedSite.UseRefinerOverrides &&
              selectedSite.Title === refiner.siteId) ||
              (!selectedSite.UseRefinerOverrides &&
                'All' === refiner.siteId)) && (
              <Refiner
                key={refiner.property}
                title={refiner.title}
                property={refiner.property}
              />
            )
        )}

      {/* Show message if there are no refiners */}
      {!!selectedSite && filteredRefiners.length === 0 && (
        <Typography align='center' color='black' marginTop={2}>
          No refiners available for this location
        </Typography>
      )}
    </Box>
  );
}
